import {
  Box,
  Flex,
  Heading,
  Image,
  LinkBox,
  Stack,
  Text,
} from "@chakra-ui/react"
import { PrintServiceProductEntityHydrated } from "@jackfruit/common"
import React, { useCallback } from "react"
import { useApplicationState } from "~/hooks/useApplicationState"
import { useProcessActions } from "~/hooks/useProcessActions"
import { useProductImages } from "~/hooks/useProductImages"
import { useProductPrices } from "~/hooks/useProductPrices"
import { formatCurrency } from "~/services/Utils"

interface Props {
  product: PrintServiceProductEntityHydrated
  layout: "vertical" | "horizontal"
}

const ProductGridItem: React.FC<Props> = ({ product, layout }) => {
  const { defaultCurrency } = useApplicationState()
  const { productImages } = useProductImages(product.id)
  const { productPrices } = useProductPrices(product.prices)
  const process = useProcessActions()
  const productPrice = productPrices.find(
    price => price?.currency === defaultCurrency
  )
  const productImage = productImages[0] || null
  const imageObjectFit =
    productImage?.metaData?.web?.grid?.imageFillType || "cover"

  const handleSelectProduct = useCallback(() => {
    process.createLineItem({
      productId: product.id,
      createFromProduct: true,
    })
  }, [process, product.id])

  return (
    <LinkBox
      bg="white"
      mx="auto"
      mb={4}
      rounded="base"
      overflow="hidden"
      boxShadow="md"
      cursor="pointer"
      onClick={handleSelectProduct}
      className={`product-grid-item product-grid-item-${layout}`}
    >
      <Box className="product-grid-image">
        <Image
          src={productImage?.thumbnail || "https://via.placeholder.com/150"}
          objectFit={imageObjectFit}
        />
      </Box>

      <Stack className="product-grid-name" justify="center" px={2}>
        <Box>
          <Flex h={12} align="center" pt={2}>
            <Heading as="h3" size="sm">
              {product.shortDescription}
            </Heading>
          </Flex>
          {productPrice && (
            <Text fontSize="sm" color="gray.400">
              {formatCurrency(productPrice.currency, productPrice.total)}
            </Text>
          )}
        </Box>
      </Stack>
    </LinkBox>
  )
}

export default ProductGridItem
